export default function ($translate) {
    return {
        KEYS: {
            NOT_STARTED: 'NOT_STARTED',
            STARTED: 'STARTED',
            STOPPED: 'STOPPED',
            CANCELLED: 'CANCELLED'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('planningGroup.Not started'),
            STARTED: $translate.instant('planningGroup.Started'),
            STOPPED: $translate.instant('planningGroup.Stopped'),
            CANCELLED: $translate.instant('planningGroup.Cancelled')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/automated/planning/group/status/index.js